const image = {
  marblShape: require('assets/img/marbl/marblShape.png'),
  marblButton: require('assets/img/marbl/marblButton.png'),
  background: require('assets/img/marbl/background.png'),
  logo: require('assets/img/marbl/logo.png'),
};
export default image;
